import {create} from 'zustand';

interface ButtonState {
    createButton: boolean;
    setCreateButton: (createButton: boolean) => void;
    
    resetButton: () => void;
}

export const useButtonStore = create<ButtonState>((set) => ({
    createButton: false,
    setCreateButton: (createButton) => set({createButton}),

    resetButton: () => set({createButton: false})
}))